import $ from 'jquery';

// Config
import { fancyboxConfig } from '../config';

export default class FancyboxCarousel {
    constructor(el, flkty) {
        this.DOM = {el: el};
        this.DOM.images = Array.from(this.DOM.el.querySelectorAll('[data-slide-image]'));
        this.DOM.toggles = Array.from(document.querySelectorAll(this.DOM.el.dataset.carouselFancyboxToggle));

        this.fancyboxItems = this.DOM.images.map(image => { return { src: image.dataset.slideImage } });
        this.flickity = flkty;

        this.initEvents();
    }

    initEvents = () => {
        this.DOM.images.forEach(image => image.addEventListener('click', this.openFancybox));
        this.DOM.toggles.forEach(toggle => toggle.addEventListener('click', this.openFancybox));

        this.flickity.on('dragStart', () => this.flickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none"));
        this.flickity.on('dragEnd', () => this.flickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all"));
    }

    openFancybox = () => {
        const index = this.flickity.selectedIndex;

        $.fancybox.open(this.fancyboxItems, {
            beforeClose: (instance, current, event) => {
                this.flickity.select(current.index);
            },
            ...fancyboxConfig
        }, index);
    }
}
